import React, {useState, useRef} from 'react';
import styled, { keyframes } from 'styled-components'
import NavBar from '../Components/NavBar';
import PaystackButton from 'react-paystack';
import SideBar from '../Components/SideBar';
import MobileNav from '../Components/MobileNav';
import history from '../history'

const animUL = keyframes`
from {
    transform: translateY(2rem);
    opacity: .5;
}
to {
    transform: translateY(0rem);
    opacity: 1; 
}
`

const VIEW = styled.section`
display: grid;
grid-template-columns: 50% 50%;
section:first-child + section {
    padding: 0 1rem auto 1rem;
    @media screen and (max-width: 48rem) {
        display: none
    }

    img {
         height: 70%;
        width: 70%;
        margin: 10 auto auto auto;
    
    }
    ul {
        animation: ${animUL} ease-in-out 3s;
        margin: 3rem 3rem 0 3rem;
        width: fit-content;
        li {
             font-size: .8rem;
            list-style-type: none;
            margin-top: 2rem;
            vertical-align: middle;
             span {
                background: #E29A07;
                width: 1rem;
                display: inline-block;
                height: 1rem;
                vertical-align: bottom;
                border-radius: 50%;
            }
        }
        
     }

}
    section:first-child {
        padding-top: 5rem;
        @media screen and (max-width: 48rem) {
            grid-column-start: 1 ;
            grid-column-end: none
        }
        h1 {

            text-align: center;
            height: 42px;
            margin-top: 40px;
            font-family: Roboto;
           font-style: normal;
           font-weight: 900;
           font-size: 30px;
           line-height: 47px;
           color: #261431;

        }
         
        input + input {
            margin: 1.5rem auto;

        }
        input {
            display: block;
            padding: 1rem .5rem;
            width: 70%;
            width: 60%;
            border-bottom: 2px solid rgba(38, 20, 49, 0.97);
            border-top: transparent;
            border-left: transparent;
            border-right: transparent;
            font-size: 14px;
            text-indent: 7px;
            text-transform: lowercase;
            line-height: 28px;
            text-align: justify;
            margin: 3rem auto;
            outline: none;
        }
        }

`
const PayEase = () => {
    const[email, setMail] = useState('')
    // const[pass, setPass] = useState('')
    // const[amount, setAmount] = useState('')
    const[phone,] = useState('')
    const[conFill, setConfil] = useState(true)
    const mailVal = useRef(null)

    const[key,] = useState(

        `${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PAY_STACK_LIVE : process.env.REACT_APP_PAY_STACK_TEST} `) 
 

    const callback = async res => {
        try {
          let {status} = res
        //   console.log(res.reference)
          if( status === 'success') {
              sessionStorage.setItem('ref', `${res.reference}`)
              
               history.push(`/confirmPay/${email}`)
 
               
          }  else throw Error
        }
         catch (error) {
            //  console.log(error, 'from pay stack')
        }
       
    }
    const close = () => console.log('Payment closed')

    const handlePay = e => {

            setMail(e.target.value)

         if(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value)) {
            setConfil(false)

        } else  setConfil(true)
    }


    return ( 
        <>
 <NavBar /> 
<MobileNav />
<SideBar showMe={ ""} />
        <VIEW>
            <section>
                <h1 id="dashH">Iamwealthy</h1>
                <form onSubmit={e => e.preventDefault()}>

                <input 
                type="email"
                placeholder='myemail@gmail.com | @yahoomail.com'
                required
                ref={mailVal}
                onChange={e => handlePay(e)}
                />

                <input 
                type="phone"
                placeholder="+00-0000-000-000"
                

                />
        <PaystackButton
         text={`Pay - NGN500`}
         className="payBtnNew"
         callback={callback}
         close={close}
         disabled={conFill}
          embed={false}  
         email={email}
         amount={50000}
         paystackkey={key}
         phone={phone}
         tag="button" />
                 
 
                </form>

  

            </section>

            <section>
               <img src={require('../../src/Assets/Images/bgPay.png')} alt="pay at ease" />

               <ul>
             <li><span></span> <strong>Pay:</strong> make a monthly payment of NGN 500  </li>
             <li><span></span><strong>Structure:</strong> You can use our best models for your finance management and with ease </li>
             <li><span></span><strong>Inspired:</strong> Stay motivated and inspired every day</li>
             <li><span></span><strong>Analysis:</strong> Seamlessly track your finance every time</li>
         </ul>

            </section>


        </VIEW>
        



        </>
     );
}
 
export default PayEase;